import React, { useState } from 'react'
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import { ExpandMore } from '@mui/icons-material';
import { Box, Modal, Skeleton } from '@mui/material';
import AppleIcon from '@mui/icons-material/Apple';
import HttpIcon from '@mui/icons-material/Http';
import ImageModal from '../ImageModal';

function ProductCard({title, shortDesc, content, img, video, appstore, url}) {
    
    const [expanded, setExpanded] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [loadingImage, setLoadingImage] = useState(true)
    const [showImageModal, setShowImageModal] = useState(false)
    const [selectedImage, setSelectedImage] = useState('')  

    const handleExpandClick = () => {
        setExpanded(!expanded)
    }
    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      bgcolor: 'background.paper',
      border: '2px solid #000',
      boxShadow: 24,
      p: 4,
    };
    const handleClickedImage = (image) => {
      console.log('image: ', image)
      setSelectedImage(image)
      setShowImageModal(true)
  }
    // console.log('LOADING IMAGE: ', loadingImage)
    //sx={{ maxWidth: 345 }} in card
  return (
    <Box>
      <ImageModal open={showImageModal} setOpen={setShowImageModal} source={selectedImage} />
      <Modal
        open={showModal}
        onClose={()=> setShowModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Youtube video of the product
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Description
          </Typography>
          <iframe width="408" height="583" src={`https://www.youtube.com/embed/${video}`} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </Box>

      </Modal>
        <Card sx={{ width: 350, maxWidth:350, marginBottom:2, borderRadius:4 }} elevation={12}  >
        <CardHeader
          action={
            <>            
            {video && (
              <IconButton 
                aria-label="watch video" 
                onClick={()=> setShowModal(!showModal)}
                sx={{
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'scale(1.2) rotate(10deg)',
                    backgroundColor: 'rgba(255, 0, 0, 0.1)',
                    boxShadow: '0 4px 20px rgba(255, 0, 0, 0.3)',
                  }
                }}
              >
                <OndemandVideoIcon />             
              </IconButton>
            )}

            {appstore && (
              <IconButton 
                aria-label="open in app store" 
                onClick={() => {window.open(appstore, '_blank')}}
                sx={{
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'scale(1.15) translateY(-3px)',
                    backgroundColor: 'rgba(0, 122, 255, 0.1)',
                    boxShadow: '0 6px 25px rgba(0, 122, 255, 0.4)',
                  }
                }}
              >              
                <AppleIcon />
              </IconButton>
            )}

            {url && (
              <IconButton 
                aria-label="open website"  
                onClick={() => {window.open(url, '_blank')}}
                sx={{
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'scale(1.1) rotate(-5deg)',
                    backgroundColor: 'rgba(76, 175, 80, 0.1)',
                    boxShadow: '0 5px 22px rgba(76, 175, 80, 0.3)',
                  }
                }}
              >              
                <HttpIcon />
              </IconButton>
            )}
            </>
          }
          title={title}
          titleTypographyProps={{
            align: 'center',
            sx: { 
              flexGrow: 1, 
              textAlign: 'center',
            }
          }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            '& .MuiCardHeader-content': {
              textAlign: 'center',
              flexGrow: 1,
              display: 'flex',
              justifyContent: 'center'
            },
            '& .MuiCardHeader-action': {
              margin: 0,
              alignSelf: 'center'
            }
          }}
        />
        {        
          loadingImage && <Skeleton variant="rectangular" width={350} height={194} animation="wave" />
        }
        <button style={{backgroundColor:'transparent'}} onClick={() => handleClickedImage(img)} >
          <CardMedia
            component={"img"}
            height="194"          
            image={img}
            alt="Photo"
            style={ loadingImage ? {display:'none' } : { objectFit:'contain' }}
            onLoadStartCapture={() => console.log('START CAPTURE')}
            // onLoadStart={() => console.log('ONLOADSTART')}
            // onLoad={() => console.log('ONLOAD FINISHED')}
            onLoad={() => setLoadingImage(false)}
          />
        </button>
        
        
        <CardContent>
          <Typography variant="body2" color="text.secondary">
            {shortDesc}
          </Typography>
        </CardContent>
        {/* <CardActions disableSpacing>        
          <ExpandMore
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <ExpandMoreIcon />
          </ExpandMore>
        </CardActions> */}
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>          
            <Typography paragraph>
              {content}
            </Typography>
            
          </CardContent>
        </Collapse>
      </Card>
    </Box>
  )
}

export default ProductCard